// ChatComponent.js
import React, { useState } from 'react';
import axios from 'axios';

const ChatComponent = () => {
    const [message, setMessage] = useState('');
    const [chatLog, setChatLog] = useState([]);

    const handleSend = async () => {
        if (!message.trim()) return;

        const userMessage = { role: 'user', content: message };
        setChatLog([...chatLog, userMessage]);

        try {
            const response = await axios.post('/api/chat', { message });
            const assistantMessage = response.data.choices[0].message;
            setChatLog([...chatLog, userMessage, assistantMessage]);
        } catch (error) {
            console.error('Error:', error);
        }

        setMessage('');
    };

    return (
        <div className='mt-10 py-5'>
            <div>
                {chatLog.map((log, index) => (
                    <div key={index} className={log.role === 'user' ? 'user-message' : 'assistant-message'}>
                        {log.content}
                    </div>
                ))}
            </div>
            <input
                type="text"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                onKeyPress={(e) => e.key === 'Enter' && handleSend()}
            />
            <button onClick={handleSend}>Send</button>
        </div>
    );
};

export default ChatComponent;
